<mat-toolbar class="mat-elevation-z3 d-flex justify-content-between z-3 position-relative">
  <div class="d-flex align-items-center justify-content-center">
    <button mat-icon-button (click)="toggleSidebar()">
      <mat-icon style="color: white;">menu</mat-icon>
    </button>
  </div>
  <div>
    <mat-menu #languageMenu="matMenu">
      <button mat-menu-item (click)="changeLanguage('en')">
        <span>English</span>
      </button>
      <button mat-menu-item (click)="changeLanguage('el')">
        <span>Ελληνικά</span>
      </button>
    </mat-menu>

    <button mat-icon-button [matMenuTriggerFor]="languageMenu">
      <mat-icon style="color: white;">language</mat-icon>
    </button>
    @if (environment.agrinio) {
    <button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="me-2 position-relative">
      <mat-icon>notifications</mat-icon>
      @if (unseenCount > 0) {
      <mat-badge [matBadge]="unseenCount" matBadgeColor="warn" matBadgeOverlap="false"></mat-badge>
      }
    </button>

    <mat-menu #notificationMenu="matMenu" class="notification-menu">
      <div class="notification-header px-3 py-2 d-flex justify-content-between align-items-center">
        <h4 class="mb-0 fw-semibold">Notifications</h4>
        <button mat-icon-button (click)="refreshNotifications(); $event.stopPropagation()" [disabled]="!isConnected"
          matTooltip="Refresh notifications">
          <mat-icon [class.spin]="!(notifications$ | async)">refresh</mat-icon>
        </button>
      </div>
      <mat-divider></mat-divider>
      <div class="notification-list p-0">
        @if (notifications$ | async; as notifications) {
        @if (notifications.results.length > 0) {
        @for (notification of notifications.results; track notification.uuid) {
        <button mat-menu-item (click)="markAsSeen(notification.uuid); $event.stopPropagation()"
          class="notification-item position-relative" [class.unseen]="!notification.seen_at">
          <div class="d-flex flex-column w-100">
            <div class="d-flex justify-content-center align-items-start">
              <span class="fw-medium" [class.text-muted]="notification.seen_at">
                {{ notification.title }}
              </span>
              <span class="text-muted small me-3">{{ notification.sent_at | date:'shortTime' }}</span>
              <span class="status-dot" [class.unseen]="!notification.seen_at"></span>
            </div>
            <span class="small mt-1 text-wrap">{{ notification.body }}</span>
          </div>
          @if ($last) {
          <mat-divider></mat-divider>
          }
        </button>
        }
        } @else {
        <div class="empty-state px-3 py-4 text-center">
          <mat-icon class="empty-icon mb-2">notifications_off</mat-icon>
          <p class="text-muted mb-0">No notifications yet</p>
        </div>
        }
        } @else {
        <div class="px-3 py-4 d-flex justify-content-center align-items-center">
          <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
        </div>
        }
      </div>
      <div class="px-3 py-2 text-center border-top">
        <small class="text-muted">
          @if (isConnected) {
          <span class="text-success">• Connected</span>
          } @else {
          <span class="text-danger">• Disconnected</span>
          }
        </small>
      </div>
    </mat-menu>
    }
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon style="color: white;">account_circle</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <mat-icon>settings</mat-icon>
        <span>{{ 'ACCOUNT' | translate }}</span>
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>{{ 'LOGOUT' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>